import { CombinedState, combineReducers } from 'redux';

import { ICredentialsState, credentials } from './credentials/credentials.reducer';
import { ICodeDataState, codeData } from './codeData/codeData.reducer';

export interface IAcceptGiftCodeState {
  credentials: ICredentialsState;
  codeData: ICodeDataState;
}

export const acceptGiftCode = combineReducers<CombinedState<IAcceptGiftCodeState>>({
  credentials,
  codeData,
});
